const prepareBlobByType = (data, type) => {
  switch (type) {
    case 'xlsx':
      return new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    case 'csv':
    default:
      return new Blob([data], { type: 'text/csv' });
  }
};

export default function generateFile(filename, data, type) {
  const blob = prepareBlobByType(data, type);
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = filename;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
    window.URL.revokeObjectURL(elem.href);
  }
}
